import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useShowContext } from 'react-admin'
import { Authority } from '../../../../../core/auth/Authority'
import Button from '../../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../../hooks/useHasAuthority'
import { SetCredentialsDialog } from '../CameraServerDialogs'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const CameraServerSetCredentialsButton = () => {
  const { loading } = useShowContext()
  const classes = useStyles()
  const [credentialsModalOpen, setCredentialsModalOpen] = useState(false)
  const hasAuthority = useHasAuthority()

  const handleSetCredentialsDialog = () => {
    setCredentialsModalOpen(true)
  }

  return (
    <>
      <SetCredentialsDialog
        open={credentialsModalOpen}
        close={() => setCredentialsModalOpen(false)}
      />
      <Button
        variant="contained"
        onClick={handleSetCredentialsDialog}
        color="primary"
        className={classes.button}
        label="resources.camera-servers.actions.setCredentials"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.CAMERA_SERVERS_MANAGE_CREDENTIALS_BUTTON) ||
          loading
        }
      />
    </>
  )
}
